module.exports = __webpack_public_path__ + "static/media/Oaknut-hero-illustration.e43d9449.svg";